export default __webpack_public_path__ + "static/media/AWSBillingAlert.fa590270.md";